
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaitotrimbakeshwercab() {



    const cardData =
    {
        keyword: 'Mumbai to Trimbakeshwar Cab',
        heading: 'S9 Travels: Mumbai to Trimbakeshwar Cab',
        headingDescription: 'S9 Travels offers Mumbai to Trimbakeshwar Cab Service, ensuring a comfortable, reliable, and hassle-free journey to the sacred Trimbakeshwar Jyotirlinga Temple. Whether you’re traveling for pilgrimage or leisure, our Innova cabs provide a smooth and safe ride. With spacious interiors, luxury features, and professional drivers, we guarantee a stress-free travel experience. Enjoy on-time pickups, affordable pricing, and 24/7 service. Book your Mumbai to Trimbakeshwar cab with S9 Travels for a seamless and divine journey!',


        top: 'Top Places to Visit in Trimbakeshwar with S9 Travels',

"topPlaces": [
    {
      "title": "Trimbakeshwar Temple",
      "description": "One of the twelve Jyotirlingas of Lord Shiva, Trimbakeshwar Temple is a sacred pilgrimage site known for its unique three-faced Shiva Lingam."
    },
    {
      "title": "Brahmagiri Hill",
      "description": "A holy mountain near Trimbakeshwar, Brahmagiri Hill is considered the origin of the sacred Godavari River and offers a scenic trek with panoramic views."
    },
    {
      "title": "Kushavarta Kund",
      "description": "A sacred water tank near Trimbakeshwar Temple, Kushavarta Kund is believed to be the source of the Godavari River and is used for ritual baths."
    },
    {
      "title": "Anjaneri Hills",
      "description": "Believed to be the birthplace of Lord Hanuman, Anjaneri Hills is a popular trekking spot with ancient caves and a Hanuman temple."
    },
    {
      "title": "Gangadwar",
      "description": "A revered site located on Brahmagiri Hill, Gangadwar is believed to be the place where the holy Godavari River first emerges."
    },
    {
      "title": "Neel Parbat",
      "description": "A scenic hill near Trimbakeshwar, Neel Parbat is a great place for trekking and offers mesmerizing views of the surrounding landscape."
    },
    {
      "title": "Harihar Fort",
      "description": "A unique and thrilling fort trek near Trimbakeshwar, Harihar Fort is famous for its steep rock-cut steps and breathtaking views."
    },
    {
      "title": "Gajanan Maharaj Ashram",
      "description": "A peaceful spiritual retreat dedicated to Saint Gajanan Maharaj, this ashram offers meditation and spiritual discourses."
    },
    {
      "title": "Vaitarna Dam",
      "description": "A beautiful dam near Trimbakeshwar, Vaitarna Dam is a serene getaway surrounded by lush greenery, perfect for nature lovers."
    },
    {
      "title": "Saptashrungi Temple",
      "description": "Located a short drive from Trimbakeshwar, this temple is dedicated to Goddess Saptashrungi and is a revered Shakti Peetha in Maharashtra."
    }
],

"services": [
    {
      "name": "Mumbai Online Cab Booking",
      "description": "Book your cab online with S9 Travels for a seamless and convenient ride in Mumbai. Our online booking system ensures you get a taxi at your fingertips, anytime, anywhere in the city."
    },
    {
      "name": "Book Cabs Online in Mumbai",
      "description": "Easily book cabs online in Mumbai with S9 Travels. Whether you need a taxi for a quick trip or a day-long journey, our online booking platform makes it simple and fast."
    },
    {
      "name": "Affordable Taxi Service in Mumbai Online",
      "description": "Get an affordable taxi service in Mumbai by booking online with S9 Travels. Our competitive rates ensure that you travel in comfort without breaking the bank."
    },
    {
      "name": "Mumbai Online Taxi Reservations",
      "description": "Reserve your taxi online in Mumbai with S9 Travels. Our quick and easy reservation process guarantees a smooth travel experience from start to finish."
    },
    {
      "name": "Private Online Cab Booking for Mumbai",
      "description": "For a more personalized travel experience, book a private cab online in Mumbai with S9 Travels. Enjoy a comfortable ride with professional drivers who prioritize your convenience."
    },
    {
      "name": "Mumbai Taxi Service for All Needs",
      "description": "S9 Travels offers a versatile taxi service for all your needs in Mumbai. From business trips to family outings, our online booking system allows you to find the perfect ride for any occasion."
    },
    {
      "name": "Book Mumbai Taxi Through App",
      "description": "Download our app and book a taxi in Mumbai instantly. Whether you're traveling for business or leisure, S9 Travels provides quick and reliable taxi services with just a few taps."
    },
    {
      "name": "Mumbai Airport Taxi Online Booking",
      "description": "Book your airport taxi in Mumbai online with S9 Travels. We provide prompt, reliable, and comfortable airport transfers for a hassle-free start or end to your journey."
    },
    {
      "name": "Instant Online Cab Booking for Mumbai",
      "description": "Need a cab urgently? Use S9 Travels' instant online cab booking service in Mumbai. Get a ride at your convenience, no matter the time of day or night."
    },
    {
      "name": "Online Taxi Service for Sightseeing in Mumbai",
      "description": "Explore the sights of Mumbai with our online taxi booking service. Whether it’s a visit to the Gateway of India, Marine Drive, or other famous landmarks, we provide comfortable rides for your sightseeing tour."
    },
    {
      "name": "Professional Online Cab Booking in Mumbai",
      "description": "Book your professional taxi online in Mumbai with S9 Travels. Our well-trained drivers and premium vehicles ensure a smooth and professional ride every time."
    }
],

"tableData": [
  ["Mumbai Online Cab Booking", "Book Cabs Online in Mumbai"],
  ["Affordable Taxi Service in Mumbai Online", "Mumbai Online Taxi Reservations"],
  ["Private Online Cab Booking for Mumbai", "Mumbai Taxi Service for All Needs"],
  ["Book Mumbai Taxi Through App", "Mumbai Airport Taxi Online Booking"],
  ["Instant Online Cab Booking for Mumbai", "Online Taxi Service for Sightseeing in Mumbai"],
  ["Professional Online Cab Booking in Mumbai", ""]
],





"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Scenic Journey",
    "WhyChoosedescription": "S9 Travels provides a comfortable Mumbai to Trimbakeshwar cab service for a smooth and relaxing ride. Our fleet of well-maintained vehicles, including the Toyota Innova, ensures a comfortable journey as you travel through scenic landscapes towards Trimbakeshwar."
  },
  {
    "WhyChooseheading": "Timely and Reliable Service",
    "WhyChoosedescription": "We understand the importance of timely arrivals. Our Mumbai to Trimbakeshwar cab service ensures that you are picked up and dropped off at the right time, whether for a religious visit, family trip, or special occasion, guaranteeing a punctual and reliable experience."
  },
  {
    "WhyChooseheading": "Experienced and Knowledgeable Drivers",
    "WhyChoosedescription": "Our experienced drivers are familiar with the best routes from Mumbai to Trimbakeshwar, ensuring a safe and efficient trip. With their knowledge of the area, you can rest assured that your journey will be smooth, safe, and stress-free."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable pricing for the Mumbai to Trimbakeshwar cab service with transparent costs. Our pricing is straightforward, with no hidden charges, and a clear breakdown provided during the booking process so that you can plan your budget accordingly."
  },
  {
    "WhyChooseheading": "Safety and Comfort Throughout the Trip",
    "WhyChoosedescription": "Your safety is our top priority. Our vehicles are equipped with modern safety features, including GPS tracking, airbags, and seat belts. Whether you’re traveling with family or solo, you can be confident that your Mumbai to Trimbakeshwar trip will be secure and comfortable."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Travel",
    "WhyChoosedescription": "S9 Travels operates 24/7, allowing you to book your Mumbai to Trimbakeshwar cab at any time that fits your schedule. Whether you want to travel early in the morning or return late at night, we offer flexible availability for your convenience."
  },
  {
    "WhyChooseheading": "Customizable Itinerary for Your Trip",
    "WhyChoosedescription": "We offer customizable itineraries for your Mumbai to Trimbakeshwar journey. Whether you want to make additional stops along the way or have specific requirements for your trip, we can tailor the journey to suit your preferences and needs."
  },
  {
    "WhyChooseheading": "Easy and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your Mumbai to Trimbakeshwar cab with S9 Travels is simple and hassle-free. You can easily book online via our website or app, or contact our customer service team for assistance. We strive to ensure a seamless and quick booking experience."
  }
]












    }


    const faqData = [
        [
          {
            question: 'How can I book a cab from Mumbai to Trimbakeshwar with S9 Travels?',
            answer: 'Booking a cab from Mumbai to Trimbakeshwar is simple! You can book your ride via our website or app, or contact our customer service team for personalized assistance in planning your journey to this sacred pilgrimage site.',
          },
          {
            question: 'What types of vehicles are available for Mumbai to Trimbakeshwar travel?',
            answer: 'We offer a range of vehicles for your journey from Mumbai to Trimbakeshwar, including sedans, SUVs, and premium vehicles like the Toyota Innova. Whether you’re traveling alone or in a group, we have the perfect vehicle for your needs.',
          },
          {
            question: 'How long does the journey from Mumbai to Trimbakeshwar take?',
            answer: 'The journey from Mumbai to Trimbakeshwar typically takes around 4.5 to 5 hours, depending on road conditions and traffic. Our experienced drivers ensure a smooth and comfortable ride along the scenic route.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel like Mumbai to Trimbakeshwar?',
            answer: 'Yes, our drivers are highly experienced in long-distance travel and are familiar with the best routes to Trimbakeshwar. They prioritize your comfort and safety throughout the journey.',
          },
          {
            question: 'Can I book a round trip for Mumbai to Trimbakeshwar?',
            answer: 'Yes, you can book a round-trip cab for your journey from Mumbai to Trimbakeshwar. Simply provide us with your return details, and we’ll ensure a smooth and timely return trip to Mumbai.',
          },
          {
            question: 'Is there a fixed fare for Mumbai to Trimbakeshwar cab service?',
            answer: 'The fare for Mumbai to Trimbakeshwar travel depends on the type of vehicle, trip duration, and any specific requirements. Contact us for a customized quote, and we’ll provide you with transparent pricing.',
          },
          {
            question: 'Do you provide pick-up services from Mumbai airport or hotels for Trimbakeshwar trips?',
            answer: 'Yes, we provide convenient pick-up services from Mumbai airport or hotels. Our driver will ensure a comfortable transfer, ensuring a smooth start to your spiritual journey to Trimbakeshwar.',
          },
          {
            question: 'Can I request additional stops on the way to Trimbakeshwar?',
            answer: 'Yes, we can accommodate additional stops for meals, sightseeing, or other breaks along the way. Just let us know your preferred stops when booking, and we’ll customize your itinerary to include them.',
          },
          {
            question: 'Is there any extra charge for waiting or detours during the Mumbai to Trimbakeshwar trip?',
            answer: 'Any extra charges for waiting time or detours will be communicated to you upfront when you book your trip. We ensure transparency and keep you informed about any additional costs.',
          },
          {
            question: 'Why should I choose S9 Travels for my Mumbai to Trimbakeshwar cab service?',
            answer: 'S9 Travels offers reliable, safe, and comfortable cab services for your journey from Mumbai to Trimbakeshwar. With well-maintained vehicles, professional drivers, and excellent customer support, we ensure your trip is smooth, timely, and enjoyable.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Rahul Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab with S9 Travels for my trip to Trimbakeshwar from Mumbai, and it was an excellent experience. The driver was professional and knowledgeable about the route. The vehicle was clean and comfortable, making the long drive smooth. Highly recommend their service for any long-distance trips!”',
        },
        {
          name: 'Mrs. Anjali Yadav',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our journey from Mumbai to Trimbakeshwar with S9 Travels was wonderful. The vehicle was spacious, and the driver was very courteous. We felt safe and relaxed throughout the trip. I will definitely use S9 Travels again for future trips!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Mumbai to Trimbakeshwar Cab",
        "description": "Book affordable and reliable Mumbai to Trimbakeshwar cab services for one-way trips, round trips, and pilgrimage tours. S9 Travels offers private taxi rides for a comfortable and scenic journey from Mumbai to Trimbakeshwar, ideal for group travel and temple tours.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };

      
     
      
      
      


    return (
        <div>
              
      <Helmet>
        <title>Mumbai to Trimbakeshwar Cab | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Mumbai to Trimbakeshwar taxi services, including one-way, round-trip, and private cabs. Affordable transport for pilgrimage trips, group travel, and comfortable sightseeing tours from Mumbai to Trimbakeshwar with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/58.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitotrimbakeshwercab;